import React from 'react';
import { useWalkie } from '../contexts/WalkieContext';

export default function ChannelMemberList() {
  const { members, activeChannelId, channels, toggleMemberMute } = useWalkie();

  const activeChannel = channels.find(c => c.id === activeChannelId);

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-700">
        <h3 className="text-sm font-semibold text-gray-300">
          الأعضاء النشطون
        </h3>
        {activeChannel && (
          <p className="text-xs text-gray-500 mt-1">
            {activeChannel.name} — {members.length} عضو
          </p>
        )}
      </div>

      {/* Member list */}
      <div className="flex-1 overflow-y-auto">
        {members.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-600 text-sm">
            لا يوجد أعضاء نشطون
          </div>
        ) : (
          <ul className="divide-y divide-gray-800">
            {members.map(member => (
              <li
                key={member.userId}
                className="flex items-center justify-between px-4 py-3 hover:bg-gray-800/50 transition-colors"
              >
                {/* Member info */}
                <div className="flex items-center gap-3">
                  {/* Avatar circle */}
                  <div className={`
                    w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold
                    ${member.isSpeaking
                      ? 'bg-emerald-600 text-white'
                      : 'bg-gray-700 text-gray-400'
                    }
                  `}>
                    {member.name.charAt(0)}
                  </div>

                  <div>
                    <div className="text-sm text-gray-200 font-medium">
                      {member.name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {member.role}
                    </div>
                  </div>

                  {/* Speaking indicator */}
                  {member.isSpeaking && (
                    <span className="flex items-center gap-1 text-emerald-400 text-xs">
                      <span className="w-2 h-2 rounded-full bg-emerald-500 speaker-dot"></span>
                      يتحدث
                    </span>
                  )}
                </div>

                {/* Mute toggle */}
                <button
                  onClick={() => toggleMemberMute(member.userId)}
                  className={`
                    p-2 rounded-lg transition-colors
                    ${member.isMuted
                      ? 'bg-red-900/50 text-red-400 hover:bg-red-900'
                      : 'bg-gray-700 text-gray-400 hover:bg-gray-600'
                    }
                  `}
                  title={member.isMuted ? 'إلغاء الكتم' : 'كتم'}
                >
                  {member.isMuted ? '🔇' : '🔊'}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Footer: channel info */}
      {activeChannel && (
        <div className="px-4 py-2 border-t border-gray-700 bg-gray-900/50">
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>نوع القناة: {activeChannel.type}</span>
            <span>{activeChannel.memberCount} مشارك</span>
          </div>
        </div>
      )}
    </div>
  );
}
